<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
</script>



<template>
    <div>
        <router-view></router-view>
    </div>
</template>